module.exports = __webpack_public_path__ + "static/img/edificio.99ffb4c.png";